<template>
    <div class="navbar-brand" >
        <router-link :to="{ name : 'dashboard' }" class="d-inline-block" >
            <img src="@/assets/images/simplysift.png" alt="Simply Sift" style="height:20px; margin-bottom: 8px;" />
        </router-link>
    </div>
</template>
<script>

export default {
    name: 'logo',

    components : {
    },
    watch: {
    },
    data () {
        return {
        }
    },
    computed: {
    },
    beforeMount(){
    },
    mounted(){

    },
    destroyed(){

    },
    methods : {

    }


}
</script>